

class NoticesHelper {
    constructor() {
    }

    dateCards() {
        // configure Swiper to use modules
        const noticesSwiper = new Swiper('.notices-swiper-container', {
            direction: 'horizontal',
            slidesPerView: 2,
            a11y: true,
            keyboard: true,
            navigation: {
                nextEl: '.notices-next',
                prevEl: '.notices-prev'
              },
        });
    }

    
}

window.app.add('notices', new NoticesHelper());